<template>
	<div class="question" :class="{ 'rotated' : rotatedCard }">
		<v-layout class="column">
			<div
				class="font-blue font-capital question-title center"
				:style="`color:${$appColors.primary}`"
			>
				{{ title }}
			</div>
			<div
				xs12
				class="font-blue font-capital center question-subtitle"
				:style="`color:${$appColors.primary}`"
			>
				{{ subTitle }}
			</div>
			<div class="question-content">
				<slot name="question"></slot>
			</div>
			<div class="question-footer">
				<slot name="footer"></slot>
			</div>
		</v-layout>
	</div>
</template>
<script>

export default {
	name: 'question',
	props: {
		rotatedCard: {
			type: Boolean,
			default: false,
		},
		title: String,
		subTitle: String,
	},
};
</script>
<style lang="scss" scoped>
	.question {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 9px;
		height: 81vh;
		transform-style: preserve-3d;
		transition: all 1s ease;

		.font-capital {
			text-transform: uppercase;
		}

		&-title {
			border-bottom: 1px solid map-get($colors, gray-slider);
			font-family: map-get($fonts, bold);
			font-size: 14px;
			padding: 32px 18px;
		}

		.center {
			text-align: center;
		}

		&-subtitle {
			font-size: 12px;
			padding: 7px 0 10px;
		}

		&-footer {
			align-items: center;
			border-top: 1px solid map-get($colors, gray-slider);
			display: flex;
			height: 61px;
			justify-content: center;
		}

		&-content {
			border-top: 1px solid map-get($colors, gray-slider);
			height: calc(81vh - 205px);
			overflow: auto;
		}
	}

	.rotated {
  		transform: rotateY(-180deg);

		.column {
			transform: rotateY(180deg);
		}
	}
</style>





// WEBPACK FOOTER //
// src/components/organizational/question.vue